import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { Box, CircularProgress, Typography } from "@mui/material";
import { darken, styled, useTheme } from "@mui/material/styles";
import { MarkdownWrapper } from "../LLMChatMessages/MarkdownWrapper";
import { RoundActionIconButton } from "../../components/Buttons/ActionIconButton/RoundActionIconButton";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
const LLMMessage = styled(Box, {
    shouldForwardProp: (prop) => prop !== "isError",
})(({ theme, isError }) => ({
    alignSelf: "flex-start",
    color: isError ? theme.palette.error.light : theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    maxWidth: "100%",
    marginBottom: theme.spacing(1),
    fontSize: "0.8em",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
}));
const AssistantContent = ({ message, handleLoadSMILES, waiting, completing, isLastMessage, }) => {
    const messageUncompleted = isLastMessage && completing;
    const detectSMILES = (markdown) => {
        const regex = /<SMILES>([\s\S]*?)<\/SMILES>/g;
        return markdown.replace(regex, (match, content) => {
            return `[\`${content}\`](_custom?type=smiles)`;
        });
    };
    const isError = message.error;
    const contentTextEl = message.content.find((e) => e.type === "text");
    if (!contentTextEl)
        return null;
    const contentText = contentTextEl.text || "";
    const thinkMatch = contentText.match(/<think>([\s\S]*?)(?:<\/think>|$)/);
    const thinkContent = thinkMatch ? thinkMatch[1].trim() : "";
    const thinkAll = thinkMatch ? thinkMatch[0] : "";
    const isThinking = thinkMatch && !thinkMatch[0].endsWith("</think>");
    const answerMatch = contentText.match(/<answer>([\s\S]*?)(?:<\/answer>|$)/);
    let answerContent = answerMatch ? answerMatch[1].trim() : "";
    if (isError) {
        answerContent = contentText;
    }
    else if (contentText && !answerContent) {
        if (!thinkContent) {
            answerContent = contentText;
        }
        else if (contentText.length > thinkAll.length) {
            // No text content, think available and think < content
            answerContent = contentText
                .slice(thinkAll.length)
                .replace(/^<answer>|<\/answer>$/g, "");
        }
    }
    // if (isError || (contentText && !thinkContent && !answerContent)) {
    //   answerContent = contentText;
    // }
    const theme = useTheme();
    const textColor = theme.palette.getContrastText("#383838");
    const [isExpanded, setIsExpanded] = useState(false);
    const thinkColor = darken(theme.palette.common.white, 0.1);
    return (_jsxs(_Fragment, { children: [_jsxs(Box, Object.assign({ sx: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    fontSize: "0.7em",
                    color: thinkColor,
                    // borderRadius: theme.shape.borderRadius,
                    paddingLeft: theme.spacing(1),
                    paddingTop: theme.spacing(1),
                    maxWidth: "100%",
                    // marginBottom: theme.spacing(1),
                    // fontSize: "0.8em",
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                } }, { children: [_jsxs(Box, Object.assign({ sx: {
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            alignItems: "center",
                        } }, { children: [messageUncompleted && (waiting || isThinking) ? (_jsxs(Box, Object.assign({ sx: {
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                    gap: 1,
                                } }, { children: [_jsx(CircularProgress, { size: 12, sx: { color: thinkColor } }), _jsx(Typography, Object.assign({ color: thinkColor, variant: "caption" }, { children: "Thinking..." }))] }))) : (_jsx(_Fragment, { children: _jsx(Typography, Object.assign({ color: thinkColor, variant: "caption" }, { children: "Thought process" })) })), _jsx(RoundActionIconButton, Object.assign({ size: "small", tooltipMsg: "Hide", onClick: () => {
                                    setIsExpanded(!isExpanded);
                                }, baseColor: textColor }, { children: isExpanded ? (_jsx(ExpandLessIcon, { fontSize: "small" })) : (_jsx(ExpandMoreIcon, { fontSize: "small" })) }))] })), isExpanded && (_jsx(Box, Object.assign({ sx: {
                            borderLeft: `1px solid ${darken(theme.palette.common.white, 0.3)}`,
                            paddingLeft: 1,
                            marginLeft: 2,
                            marginBottom: 1,
                        } }, { children: _jsx(Typography, Object.assign({ color: thinkColor, variant: "caption" }, { children: thinkContent })) })))] })), _jsx(LLMMessage, Object.assign({ isError: isError }, { children: _jsx(MarkdownWrapper, Object.assign({ handleLoadSMILES: handleLoadSMILES, completing: completing }, { children: detectSMILES(answerContent) })) }))] }));
};
export default AssistantContent;
